module.exports = __webpack_public_path__ + "a089b761c1314e94ecef320bbf86ec57.svg";